import en from '@/translations/en';
import fr from '@/translations/fr';
import es from '@/translations/es';

export default {
  en,
  fr,
  es,
};
